// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1jtSiPVu2mamYgAgJ3nhpR","title":"_3S7YBFc-yEMCgfEuPcy1ar","subtitle":"qe57Gm4Q_8349p8G4uSHl","right":"_2DJHdLANcQKtUraWy9Yw1O"};